

































































































































































import {
  defineComponent,
  computed,
  inject,
  ref,
  onBeforeMount,
} from '@vue/composition-api'
import {
  publishTextbookIssue,
  publishTextbookIssuePreview,
  getTextbookIssuePublishInfo,
  getFrontendLink,
  restoreTextbookIssuePublication,
  createPreviews,
} from '@/shared/api'
import {
  PUBLISH_TEXTBOOK_ISSUE_LIVE,
  PUBLISH_TEXTBOOK_ISSUE_PREVIEW,
} from '@/shared/user/permissions'
import {
  TextbookIssue,
  TextbookIssuePublishInfo,
  TextbookIssuePublication,
} from '@/shared/types'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { formatTimestamp } from '@/shared/utils'
import PreviewTextbookIssue from './components/TextbookIssue/PreviewTextbookIssue.vue'
export default defineComponent({
  name: 'PublishTextbookIssue',
  components: {
    PreviewTextbookIssue,
  },
  setup(props, { root }) {
    const { getters, actions } = useTextbookStore()
    const { activeTextbookIssue } = getters
    const { loadTextbooks } = actions
    const $alert = inject(alertSymbol) as Function
    const publishing = ref(false)
    const liveVersion = ref(false)
    const loadingPublishInfo = ref(false)
    const publicationsOpen = ref(false)
    const publishInfo = ref(null as TextbookIssuePublishInfo)
    const showPreviewTextbookIssueDialog = ref(false)
    const { hasPermissionTo } = useUserStore().getters
    const headers = [
      {
        text: '',
        value: 'label',
        sortable: false,
      },
      {
        text: '',
        value: 'value',
        sortable: false,
      },
    ]

    const textbookIssueId = computed(() => root.$route.params.textbookIssueId)

    const items = computed(() => {
      return [
        {
          label: root.$t('textbookIssue.publishInfo.name'),
          value: publishInfo.value?.name,
        },
        {
          label: root.$t('textbookIssue.publishInfo.isbn'),
          value: publishInfo.value?.isbn,
        },
        {
          label: root.$t('textbookIssue.publishInfo.createdOn'),
          value: publishInfo.value
            ? formatTimestamp(publishInfo.value.createdOn, true)
            : null,
        },
        {
          label: root.$t('textbookIssue.publishInfo.updatedOn'),
          value: publishInfo.value
            ? formatTimestamp(publishInfo.value.updatedOn, true)
            : null,
        },
        {
          label: root.$t('textbookIssue.publishInfo.lastPublishedOn'),
          value: publishInfo.value
            ? formatTimestamp(publishInfo.value.lastPublishedOn, true)
            : null,
        },
        {
          label: root.$t('textbookIssue.publishInfo.publications'),
          value: publishInfo.value?.publications,
          name: 'publications',
        },
        {
          label: root.$t('textbookIssue.publishInfo.numberOfPages'),
          value: publishInfo.value?.numberOfPages,
        },
        {
          label: root.$t('textbookIssue.publishInfo.numberOfMediaItems'),
          value: publishInfo.value?.numberOfMediaItems,
        },

        {
          label: root.$t(
            'textbookIssue.publishInfo.numberOfMediaItemsWithOccurences'
          ),
          value: publishInfo.value?.numberOfMediaItemsWithOccurences,
        },
        {
          label: root.$t('textbookIssue.publishInfo.numberOfOccurences'),
          value: publishInfo.value?.numberOfOccurences,
        },
        {
          label: root.$t('textbookIssue.publishInfo.licenses'),
          value: publishInfo.value?.licenses.join(', '),
        },
        {
          label: root.$t('textbookIssue.publishInfo.numberOfCategories'),
          value: publishInfo.value?.numberOfCategories,
        },
        {
          label: root.$t('textbookIssue.publishInfo.numberOfActiveCategories'),
          value: publishInfo.value?.numberOfActiveCategories,
        },
        {
          label: root.$t('textbookIssue.publishInfo.missingCategories'),
          value: publishInfo.value
            ? publishInfo.value.missingCategories.length
              ? publishInfo.value?.missingCategories
                  .map((el: { filename: string }) => el.filename)
                  .join(', ')
              : root.$t('textbookIssue.publishInfo.noMissingCategories')
            : '',
        },
        {
          label: root.$t('textbookIssue.publishInfo.missingFiles'),
          // value: publishInfo.value?.missingFiles.map((el: {filename: string}) => el.filename).join(', '),
          value: publishInfo.value ? publishInfo.value.missingFiles.length : '',
        },
        {
          label: root.$t('textbookIssue.publishInfo.missingPreviewsCount'),
          value: publishInfo.value ? publishInfo.value.missingPreviewsCount : '',
          name: 'missingPreviewsCount',
        },
      ]
    })

    const refreshPublishInfo = async () => {
      try {
        loadingPublishInfo.value = true
        publishInfo.value = await getTextbookIssuePublishInfo(
          textbookIssueId.value
        )
        loadingPublishInfo.value = false
      } catch (e) {
        loadingPublishInfo.value = false
        throw e
      }
    }

    const handleClickLink = (event: Event) => {
      if (liveVersion.value) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
      if (!activeTextbookIssue.value.hasPreview) {
        $alert({
          type: 'warning',
          text: root.$t('textbookIssue.noPreviewExists', {
            textbookIssueName: activeTextbookIssue.value.name,
          }),
        })
        return
      }
      showPreviewTextbookIssueDialog.value = true
    }

    const publishTextbookIssueHandler = async (item: TextbookIssue) => {
      await $alert({
        type: 'confirm',
        text: root.$t('textbookIssue.publishConfirm', {
          textbookIssueName: item.name,
        }),
      })
      publishing.value = true
      try {
        await publishTextbookIssue(item.id)
        $alert({
          type: 'success',
          text: root.$t('textbookIssue.publishSuccess'),
        })
        publishing.value = false
        refreshPublishInfo()
      } catch (e) {
        publishing.value = false
        throw e
      }
    }
    const publishTextbookIssuePreviewHandler = async (item: TextbookIssue) => {
      await $alert({
        type: 'confirm',
        text: root.$t('textbookIssue.publishPreviewConfirm', {
          textbookIssueName: item.name,
        }),
      })
      publishing.value = true
      try {
        await publishTextbookIssuePreview(item.id)
        $alert({
          type: 'success',
          text: root.$t('textbookIssue.publishPreviewSuccess'),
        })
        publishing.value = false
        refreshPublishInfo()
      } catch (e) {
        publishing.value = false
        throw e
      }
    }

    const onRestoreHandler = async (publication: TextbookIssuePublication) => {
      await $alert({
        type: 'confirm',
        text: root.$t('textbookIssue.publish.confirmRestore', {
          textbookIssueName: publishInfo.value.name,
          fromDate: formatTimestamp(publication.createdOn, true),
        }),
      })
      if (publishing.value) {
        return
      }
      try {
        publishing.value = true
        await restoreTextbookIssuePublication(
          publishInfo.value.id,
          publication.id
        )
        $alert({
          type: 'success',
          text: root.$t('textbookIssue.publish.restoreSuccess'),
        })
        await refreshPublishInfo()
        publishing.value = false
      } catch (e) {
        publishing.value = false
        throw e
      }
    }

    const onPublishHandler = async (item: TextbookIssue) => {
      if (publishing.value) {
        return
      }
      if (liveVersion.value) {
        await publishTextbookIssueHandler(item)
      } else {
        await publishTextbookIssuePreviewHandler(item)
      }
      loadTextbooks()
    }
    const creatingPreviews = ref(false)
    const onCreatePreviewsHandler = async (item: TextbookIssue) => {
      if (creatingPreviews.value) {
        return
      }
      creatingPreviews.value = true
      try {
        await createPreviews(item.id)
        creatingPreviews.value = false
        $alert({
          type: 'success',
          text: root.$t('textbookIssue.publishInfo.createPreviewsSuccess'),
        })
      } catch(e) {
        console.error(e)
        creatingPreviews.value = false
        $alert({
          type: 'error',
          text: root.$t('textbookIssue.publishInfo.createPreviewsError'),
        })
      }
      refreshPublishInfo()
    }

    onBeforeMount(refreshPublishInfo)
    return {
      onPublishHandler,
      activeTextbookIssue,
      headers,
      items,
      publishing,
      liveVersion,
      publishInfo,
      loadingPublishInfo,
      getFrontendLink,
      handleClickLink,
      formatTimestamp,
      onRestoreHandler,
      showPreviewTextbookIssueDialog,
      PUBLISH_TEXTBOOK_ISSUE_LIVE,
      PUBLISH_TEXTBOOK_ISSUE_PREVIEW,
      hasPermissionTo,
      publicationsOpen,
      creatingPreviews,
      onCreatePreviewsHandler
    }
  },
})
